// extracted by mini-css-extract-plugin
export default {"fileUploader":"FileDragArea_fileUploader__4mN1A","dropArea":"FileDragArea_dropArea__BtoXS","cameraIcon":"FileDragArea_cameraIcon__kh7Nd","addText":"FileDragArea_addText__grhf5"};